export default __webpack_public_path__ + "static/media/fullscreen-exit.dbd49cae.svg";